import type { HeroHeaderView } from "@opensea/navigation"
import { classNames } from "@opensea/ui-kit"

type Props = {
  headerView: HeroHeaderView

  className?: string
}

export function HeroBannerMediaGradientOverlay({
  className,
  headerView,
}: Props) {
  return (
    <div
      className={classNames(
        "absolute inset-0 z-20",
        "dark bg-[linear-gradient(180deg,rgb(var(--color-bg-app)/65%)_0%,rgb(var(--color-bg-app)/40%)_25%,rgb(var(--color-bg-app)/35%)_50%,rgb(var(--color-bg-app)/75%)_75%,rgb(var(--color-bg-app))_100%)]",
        "transition-opacity duration-500 ease-out-quint",
        headerView === "compact" ? "opacity-0" : "opacity-100",
        className,
      )}
    />
  )
}
